import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=536b2552&scoped=true"
import script from "./GameDetail.vue?vue&type=script&lang=js"
export * from "./GameDetail.vue?vue&type=script&lang=js"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=536b2552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b2552",
  null
  
)

export default component.exports